import { store } from '../redux/store';
import { setMenuManagementRemoteConfig } from '../redux/actions/menuManagementRemoteConfig';
import { isFirebaseConfigured } from './config';
import {
  fetchAndActivateRemoteConfig,
  getMenuManagementRemoteConfigParamKey,
  getRemoteConfigString,
} from './remoteConfig';

export function bootstrapMenuManagementRemoteConfig(): void {
  const paramKey = getMenuManagementRemoteConfigParamKey();

  if (!isFirebaseConfigured()) {
    store.dispatch(
      setMenuManagementRemoteConfig({
        paramKey,
        raw: '',
        data: null,
        error: 'Firebase not configured',
        loaded: true,
      }),
    );
    return;
  }

  void loadMenuManagementRemoteConfig(paramKey);
}

export async function refreshMenuManagementRemoteConfig(): Promise<void> {
  const paramKey = getMenuManagementRemoteConfigParamKey();
  if (!isFirebaseConfigured()) {
    return;
  }
  await loadMenuManagementRemoteConfig(paramKey, { force: true });
}

async function loadMenuManagementRemoteConfig(
  paramKey: string,
  options: { force?: boolean } = {},
): Promise<void> {
  try {
    await fetchAndActivateRemoteConfig(options);
    const raw = getRemoteConfigString(paramKey, '');
    let data: unknown = null;
    if (raw.trim()) {
      try {
        data = JSON.parse(raw) as unknown;
      } catch {
        store.dispatch(
          setMenuManagementRemoteConfig({
            paramKey,
            raw,
            data: null,
            error: 'Invalid JSON in Remote Config',
            loaded: true,
          }),
        );
        return;
      }
    }
    store.dispatch(
      setMenuManagementRemoteConfig({
        paramKey,
        raw,
        data,
        error: null,
        loaded: true,
      }),
    );
  } catch (err) {
    store.dispatch(
      setMenuManagementRemoteConfig({
        paramKey,
        raw: '',
        data: null,
        error: err instanceof Error ? err.message : String(err),
        loaded: true,
      }),
    );
  }
}
